import { render, staticRenderFns } from "./ActualizarBolsaPrincipal.vue?vue&type=template&id=64c0b9b8"
import script from "./ActualizarBolsaPrincipal.vue?vue&type=script&lang=js"
export * from "./ActualizarBolsaPrincipal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports